export const actions = {
  GET_PERSONALIZACION_BY_PRODUCTO_REQUESTED: 'GET_PERSONALIZACION_BY_PRODUCTO_REQUESTED',
  GET_PERSONALIZACION_BY_PRODUCTO_SUCCEEDED: 'GET_PERSONALIZACION_BY_PRODUCTO_SUCCEEDED',
  GET_PERSONALIZACION_BY_PRODUCTO_FAILED: 'GET_PERSONALIZACION_BY_PRODUCTO_FAILED',

  CHOCOMENSAJE_PRODUCTO_DELETED: 'CHOCOMENSAJE_PRODUCTO_DELETED',
  IMAGEN_CLIENTE_PRODUCTO_DELETED: 'IMAGEN_CLIENTE_PRODUCTO_DELETED',
  IMAGEN_CLIENTE_PRODUCTO_INSERTED: 'IMAGEN_CLIENTE_PRODUCTO_INSERTED',

  AUDIO_PRODUCTO_DELETED: 'AUDIO_PRODUCTO_DELETED',
  AUDIO_PRODUCTO_INSERTED: 'AUDIO_PRODUCTO_INSERTED',

  INSERT_LEGOPROPS_PRODUCTO_REQUESTED: 'INSERT_LEGOPROPS_PRODUCTO_REQUESTED',
  INSERT_LEGOPROPS_PRODUCTO_SUCCEEDED: 'INSERT_LEGOPROPS_PRODUCTO_SUCCEEDED',
  INSERT_LEGOPROPS_PRODUCTO_FAILED: 'INSERT_LEGOPROPS_PRODUCTO_FAILED',

  UPDATE_LEGOPROPS_PRODUCTO_REQUESTED: 'UPDATE_LEGOPROPS_PRODUCTO_REQUESTED',
  UPDATE_LEGOPROPS_PRODUCTO_SUCCEEDED: 'UPDATE_LEGOPROPS_PRODUCTO_SUCCEEDED',
  UPDATE_LEGOPROPS_PRODUCTO_FAILED: 'UPDATE_LEGOPROPS_PRODUCTO_FAILED',

  DELETE_LEGOPROPS_PRODUCTO_REQUESTED: 'DELETE_LEGOPROPS_PRODUCTO_REQUESTED',
  DELETE_LEGOPROPS_PRODUCTO_SUCCEEDED: 'DELETE_LEGOPROPS_PRODUCTO_SUCCEEDED',
  DELETE_LEGOPROPS_PRODUCTO_FAILED: 'DELETE_LEGOPROPS_PRODUCTO_FAILED',
}

export const getPersonalizacionByProductoAction = (dispatch, payload) => {
  dispatch({
    type: actions.GET_PERSONALIZACION_BY_PRODUCTO_REQUESTED,
    payload,
  })
}

export const chocomensajeDeletedAction = (dispatch, payload) => {
  dispatch({
    type: actions.CHOCOMENSAJE_PRODUCTO_DELETED,
    payload,
  })
}

export const imagenClienteDeletedAction = (dispatch, payload) => {
  dispatch({
    type: actions.IMAGEN_CLIENTE_PRODUCTO_DELETED,
    payload,
  })
}

export const imagenClienteInsertedAction = (dispatch, payload) => {
  dispatch({
    type: actions.IMAGEN_CLIENTE_PRODUCTO_INSERTED,
    payload,
  })
}

export const audioProductoDeletedAction = (dispatch, payload) => {
  dispatch({
    type: actions.AUDIO_PRODUCTO_DELETED,
    payload,
  })
}

export const audioProductoInsertedAction = (dispatch, payload) => {
  dispatch({
    type: actions.AUDIO_PRODUCTO_INSERTED,
    payload,
  })
}

export const insertLegoPropsProductoAction = (dispatch, payload) => {
  dispatch({
    type: actions.INSERT_LEGOPROPS_PRODUCTO_REQUESTED,
    payload,
  })
}

export const updateLegoPropsProductoAction = (dispatch, payload) => {
  dispatch({
    type: actions.UPDATE_LEGOPROPS_PRODUCTO_REQUESTED,
    payload,
  })
}

export const deleteLegoPropsProductoAction = (dispatch, payload) => {
  dispatch({
    type: actions.DELETE_LEGOPROPS_PRODUCTO_REQUESTED,
    payload,
  })
}
